module.exports = __webpack_public_path__ + "static/media/building1.2465d09e.png";